import React, { Suspense } from 'react';
import { string, shape, bool, oneOfType, arrayOf } from 'prop-types';
import classnames from 'classnames';
import { Icon } from '@tesla/design-system-react';
import { iconArrow } from '@tesla/design-system-icons';
import ConfiguratorModalTrigger from '../ConfiguratorModalTrigger/index.js';

var ConfiguratorFooter = function ConfiguratorFooter(_ref) {
  var afterSavingsLabel = _ref.afterSavingsLabel,
    afterSavingsPrice = _ref.afterSavingsPrice,
    beforeSavingsPrice = _ref.beforeSavingsPrice,
    bottomPx = _ref.bottomPx,
    containerPrefix = _ref.containerPrefix,
    depositAmount = _ref.depositAmount,
    financeType = _ref.financeType,
    footerClassObject = _ref.footerClassObject,
    footerSuspenseKey = _ref.footerSuspenseKey,
    hideAfterSavingsPrice = _ref.hideAfterSavingsPrice,
    hidePaymentModalTrigger = _ref.hidePaymentModalTrigger,
    iconArrowDescription = _ref.iconArrowDescription,
    iconArrowTitle = _ref.iconArrowTitle,
    isDesktop = _ref.isDesktop,
    isReservation = _ref.isReservation,
    loanPaymentLabelMobile = _ref.loanPaymentLabelMobile,
    modalTriggerProps = _ref.modalTriggerProps,
    purchasePriceLabel = _ref.purchasePriceLabel,
    reservationLabel = _ref.reservationLabel,
    reversePricingOrder = _ref.reversePricingOrder,
    savingsAmount = _ref.savingsAmount,
    savingsAmountLabel = _ref.savingsAmountLabel,
    showBeforeSavingsPriceFinancingLabel = _ref.showBeforeSavingsPriceFinancingLabel,
    showSavingsAmount = _ref.showSavingsAmount;
  var financeLabelMobile = financeType === 'loan' && loanPaymentLabelMobile ? "".concat(loanPaymentLabelMobile) : purchasePriceLabel;
  var pricingOrder = [/*#__PURE__*/React.createElement("div", {
    key: "footer-pricing--before",
    className: "tds-flex-item tds-flex--col_1of5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tds-flex tds-text--body tds-text--medium tds-text_color--10 summary-panel--item",
    key: "beforeSavingsPrice"
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames("finance-type--".concat(financeType))
  }, beforeSavingsPrice), (showBeforeSavingsPriceFinancingLabel || !showBeforeSavingsPriceFinancingLabel && !['lease', 'loan'].includes(financeType)) && /*#__PURE__*/React.createElement("span", null, financeLabelMobile))), /*#__PURE__*/React.createElement(React.Fragment, null, isReservation && /*#__PURE__*/React.createElement("div", {
    key: "footer-pricing--next",
    className: "tds-flex-item tds-flex--col_1of5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tds-flex summary-panel--item tds-text--caption",
    key: "depositAmount"
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames("finance-type--".concat(financeType))
  }, depositAmount), /*#__PURE__*/React.createElement("span", null, reservationLabel)))), /*#__PURE__*/React.createElement(React.Fragment, null, !hideAfterSavingsPrice && /*#__PURE__*/React.createElement("div", {
    key: "footer-pricing--after",
    className: "tds-flex-item tds-flex--col_1of5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tds-flex summary-panel--item tds-text--caption",
    key: "afterSavingsPrice"
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames("finance-type--".concat(financeType))
  }, afterSavingsPrice), /*#__PURE__*/React.createElement("span", null, afterSavingsLabel))))];
  var summaryPanelContent = function summaryPanelContent() {
    return /*#__PURE__*/React.createElement("div", {
      key: "footer-main-content",
      className: "tds-flex-item summary-options"
    }, pricingOrder, showSavingsAmount && /*#__PURE__*/React.createElement("div", {
      className: "tds-flex-item tds-flex--col_1of5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tds-flex summary-panel--item tds-text--caption"
    }, /*#__PURE__*/React.createElement("span", {
      className: classnames("finance-type--".concat(financeType))
    }, savingsAmount), /*#__PURE__*/React.createElement("span", null, savingsAmountLabel))));
  };
  if (reversePricingOrder) {
    pricingOrder.reverse();
  }
  return /*#__PURE__*/React.createElement("footer", {
    id: "footer",
    className: classnames('tds-shell-footer', footerClassObject)
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('tds-flex', "cf-footer-layout cf-footer--".concat(containerPrefix)),
    style: {
      bottom: bottomPx
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames({
      'tds-layout-item': !isDesktop
    }, 'tds-flex summary-panel--footer')
  }, /*#__PURE__*/React.createElement(Suspense, {
    key: footerSuspenseKey,
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer-action-block",
    key: "footer-modal-trigger"
  }, !hidePaymentModalTrigger &&
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-props-no-spreading
  React.createElement(ConfiguratorModalTrigger, modalTriggerProps, /*#__PURE__*/React.createElement(Icon, {
    data: iconArrow,
    className: "footer-modal-trigger",
    style: {
      width: '32px',
      height: '32px'
    },
    title: iconArrowTitle,
    description: iconArrowDescription
  }), summaryPanelContent()), hidePaymentModalTrigger && summaryPanelContent())))));
};
ConfiguratorFooter.propTypes = {
  afterSavingsLabel: string,
  afterSavingsPrice: string,
  beforeSavingsPrice: string,
  bottomPx: string,
  containerPrefix: string,
  depositAmount: string,
  financeType: string,
  footerClassObject: shape({}),
  footerSuspenseKey: string.isRequired,
  hideAfterSavingsPrice: bool,
  hidePaymentModalTrigger: bool.isRequired,
  isDesktop: bool.isRequired,
  iconArrowDescription: string,
  iconArrowTitle: string,
  isReservation: bool,
  loanPaymentLabelMobile: string,
  modalTriggerProps: oneOfType([arrayOf(shape({})), shape({})]),
  purchasePriceLabel: string,
  reservationLabel: string,
  reversePricingOrder: bool,
  savingsAmount: string,
  savingsAmountLabel: string,
  showBeforeSavingsPriceFinancingLabel: bool,
  showSavingsAmount: bool
};
ConfiguratorFooter.defaultProps = {
  afterSavingsLabel: '',
  afterSavingsPrice: '',
  beforeSavingsPrice: '',
  bottomPx: '0px',
  containerPrefix: 'desktop',
  depositAmount: '',
  financeType: '',
  footerClassObject: {},
  hideAfterSavingsPrice: false,
  iconArrowDescription: '',
  iconArrowTitle: '',
  isReservation: false,
  loanPaymentLabelMobile: '',
  modalTriggerProps: {},
  purchasePriceLabel: '',
  reservationLabel: '',
  reversePricingOrder: false,
  savingsAmount: 0,
  savingsAmountLabel: '',
  showBeforeSavingsPriceFinancingLabel: true,
  showSavingsAmount: false
};

export { ConfiguratorFooter as default };
